export default __webpack_public_path__ + "static/media/SIX-Protocol-NEW-3-18.070c54c1.png";